import { BoxProps, Paper, PaperProps, SxProps, Theme } from "@mui/material";
import { ReactNode, forwardRef } from "react";

export interface AppPopperContentProps {
  /** If `true`, default styles are used. Pass `false` to don't use any styles or provide your own styles.
   * @default true
   */
  isUseDefaultStyles?: boolean;
  /** Makes the wrapper invisible so the children use their own styles. */
  isTransparent?: boolean;
  paperProps?: Partial<PaperProps>;
  sx?: SxProps<Theme>;
  children: ReactNode;
  onClick?: BoxProps["onClick"];
}

/** Wraps the content of popover. Provides default styling. */
export default forwardRef<HTMLDivElement, AppPopperContentProps>(function AppPopperContent(
  {
    isUseDefaultStyles = true,
    isTransparent = false,
    paperProps,
    sx,
    children,
    onClick,
  }: AppPopperContentProps,
  ref,
) {
  return (
    <Paper
      ref={ref}
      data-testid='AppPopperContent'
      sx={{
        ...(isUseDefaultStyles
          ? {
              maxWidth: { xxs: "95vw" },
              maxHeight: { xxs: "95vh" },
              overflow: "auto",
              py: 1,
              px: 2,
            }
          : undefined),
        ...(isTransparent
          ? {
              background: "transparent",
              border: "none",
              borderWidth: 0,
              boxShadow: "none",
            }
          : undefined),
        ...sx,
      }}
      variant='elevation'
      elevation={1}
      onClick={onClick}
      {...paperProps}
    >
      {children}
    </Paper>
  );
});
